import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights = null;

export function initAppInsights() {
    const instrumentationKey = process.env.REACT_APP_APPINSIGHTS_KEY;

    if (!instrumentationKey) {
        if (process.env.NODE_ENV === 'development') {
            // Intentionally no-op when key is absent in local environments.
            // eslint-disable-next-line no-console
            console.warn(
                '[AppInsights] REACT_APP_APPINSIGHTS_KEY is not set - telemetry disabled.'
            );
        }
        return null;
    }

    const ai = new ApplicationInsights({
        config: {
            instrumentationKey,
            enableAutoRouteTracking: true,
            enableCorsCorrelation: true
        }
    });

    ai.loadAppInsights();
    ai.trackPageView();
    appInsights = ai;
    return ai;
}

export function trackCacheEvent(eventName, key) {
    if (!appInsights) return;
    try {
        appInsights.trackEvent({ name: eventName }, { key: String(key) });
    } catch (_) {
        // Never throw from telemetry.
    }
}
